import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import { useRebrandBanner } from "../../hooks/useRebrandBanner";

const OwnerLayout = () => {
  const { totalTopOffsetPx } = useRebrandBanner();

  return (
    <Box
      component="main"
      sx={{
        width: "100%",
        minHeight: `calc(100vh - ${totalTopOffsetPx}px)`,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fcfcfc",
      }}
    >
      <Outlet />
    </Box>
  );
};

export default OwnerLayout;
